import React, { useState, useEffect } from "react";
import img1 from "../assets/images/banners/28.webp";
import imgChart from "../assets/images/charts/3.png";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    contactName: "",
    contactEmail: "",
    contactPhone: "",
    expertise: "",
    contactMessage: "",
  });

  const [services, setServices] = useState([]);
  const [loadingServices, setLoadingServices] = useState(true);
  const [submitStatus, setSubmitStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Get API configuration from localStorage
  const api_url =
    localStorage.getItem("api_url") || "http://localhost/inscape_backend/api/";
  const company_id = localStorage.getItem("company_id") || "1";
  const employee_id = localStorage.getItem("employee_id") || "1";

  useEffect(() => {
    // Fetch services for dropdown
    fetchServices();
  }, []);

  // Fetch services from API
  const fetchServices = async () => {
    try {
      setLoadingServices(true);
      const formData = new FormData();
      formData.append("company_id", company_id);
      formData.append("employee_id", employee_id);
      formData.append("type", "1"); // Type 1 for show all services

      const response = await fetch(`${api_url}service.php`, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setServices(data.result || []);
      } else {
        console.error("Failed to fetch services:", data.error);
        // Set default services if API fails
        setServices([{ service_id: "0", service_title: "General Inquiry" }]);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
      // Set default services if API fails
      setServices([{ service_id: "0", service_title: "General Inquiry" }]);
    } finally {
      setLoadingServices(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear submit status when user starts typing
    if (submitStatus) {
      setSubmitStatus("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus("");

    try {
      const submitData = new FormData();
      submitData.append("company_id", company_id);
      submitData.append("employee_id", employee_id);
      submitData.append("type", "3"); // Type 3 for insert
      submitData.append("inquiry_name", formData.contactName);
      submitData.append("inquiry_email", formData.contactEmail);
      submitData.append("inquiry_phone", formData.contactPhone);
      submitData.append("inquiry_service", formData.expertise);
      submitData.append("inquiry_message", formData.contactMessage);

      const response = await fetch(`${api_url}inquiry.php`, {
        method: "POST",
        body: submitData,
      });

      const data = await response.json();

      if (data.status === "1") {
        setSubmitStatus("success");
        // Reset form
        setFormData({
          contactName: "",
          contactEmail: "",
          contactPhone: "",
          expertise: "",
          contactMessage: "",
        });

        // Auto-hide success message after 5 seconds
        setTimeout(() => {
          setSubmitStatus("");
        }, 5000);
      } else {
        setSubmitStatus("error");
        console.error("Submission error:", data.error);
      }
    } catch (error) {
      console.error("Form submission error:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <section className="contact-layout6 section-full-width py-0">
      <div className="container">
        <div className="row">
          <div className="contact-panel d-flex flex-wrap p-0 overflow-hidden">
            {/* Contact Panel Info */}
            <div className="contact-panel-info arrow-hover-flip-up bg-overlay d-flex flex-column justify-content-between">
              <div className="bg-img">
                <img src={img1} alt="img" />
              </div>
              <div className="counter-item">
                <div className="d-flex align-items-center">
                  <h4 className="counter color-white">
                    <span className="counter-number">
                      {localStorage.getItem("number_client") || 6239}
                    </span>
                  </h4>
                </div>
                <p className="counter-desc color-white">
                  Projects and strategies
                </p>

                <div className="d-flex align-items-center">
                  <h4 className="counter color-white">
                    <span className="counter-number">
                      {localStorage.getItem("number_hours") || 24}
                    </span>
                  </h4>
                </div>
                <p className="counter-desc color-white">Always‑on support</p>
              </div>
              {/* /.counter-item */}
              <img src={imgChart} alt="chart" width="300" />
            </div>
            {/* /.contact-panel-info */}

            {/* Contact Form */}
            <form
              className="contact-panel-form"
              onSubmit={handleSubmit}
              id="contactForm"
            >
              <div className="row">
                <div className="col-12">
                  <h4 className="contact-form-title mb-20">
                    Interested in cooperation or have questions?
                  </h4>

                  {/* Success/Error Messages */}
                  {submitStatus === "success" && (
                    <div
                      className="alert alert-success mb-20"
                      role="alert"
                      style={{
                        padding: "12px 20px",
                        borderRadius: "8px",
                        backgroundColor: "#d4edda",
                        color: "#155724",
                        border: "1px solid #c3e6cb",
                        fontSize: "14px",
                      }}
                    >
                      <strong>Success!</strong> Thank you for your inquiry! We
                      will contact you soon.
                    </div>
                  )}

                  {submitStatus === "error" && (
                    <div
                      className="alert alert-danger mb-20"
                      role="alert"
                      style={{
                        padding: "12px 20px",
                        borderRadius: "8px",
                        backgroundColor: "#f8d7da",
                        color: "#721c24",
                        border: "1px solid #f5c6cb",
                        fontSize: "14px",
                      }}
                    >
                      <strong>Error!</strong> Something went wrong. Please try
                      again or contact us directly.
                    </div>
                  )}
                </div>
                {/* /.col-12 */}

                {/* Name */}
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="contact-name">
                      Your Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="John Smith"
                      id="contact-name"
                      name="contactName"
                      value={formData.contactName}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  {/* /.form-group */}
                </div>
                {/* /.col-lg-6 */}

                {/* Email */}
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="contact-email">
                      Email Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="john@example.com"
                      id="contact-email"
                      name="contactEmail"
                      value={formData.contactEmail}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  {/* /.form-group */}
                </div>
                {/* /.col-lg-6 */}

                {/* Phone */}
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="contact-Phone">
                      Phone Number <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="+1234567890"
                      id="contact-Phone"
                      name="contactPhone"
                      value={formData.contactPhone}
                      onChange={handleChange}
                      autoComplete="off"
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
                {/* /.col-lg-6 */}

                {/* Service (Dynamic Dropdown) */}
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="expertise">
                      Service <span style={{ color: "red" }}>*</span>
                    </label>
                    {loadingServices ? (
                      <select className="form-control" disabled>
                        <option>Loading services...</option>
                      </select>
                    ) : (
                      <select
                        className="form-control"
                        id="expertise"
                        name="expertise"
                        value={formData.expertise}
                        onChange={handleChange}
                        required
                        disabled={isSubmitting}
                      >
                        <option value="">-- Select a Service --</option>
                        {services.map((service) => (
                          <option
                            key={service.service_id}
                            value={service.service_title}
                          >
                            {service.service_title}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {/* /.form-group */}
                </div>
                {/* /.col-lg-6 */}

                {/* Message */}
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="contact-message">
                      Business Description
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Kindly provide enough information about your business..."
                      id="contact-message"
                      name="contactMessage"
                      value={formData.contactMessage}
                      onChange={handleChange}
                      rows="4"
                      disabled={isSubmitting}
                    ></textarea>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    className="btn btn-secondary same-hover arrow-hover-flip-up mt-30"
                    disabled={isSubmitting}
                    style={{
                      opacity: isSubmitting ? 0.6 : 1,
                      cursor: isSubmitting ? "not-allowed" : "pointer",
                    }}
                  >
                    <span>
                      {isSubmitting ? "Submitting..." : "Submit Request"}
                    </span>
                    {!isSubmitting && (
                      <svg
                        className="arrow-flip"
                        enableBackground="new 0 0 64 64"
                        viewBox="0 0 64 64"
                        width="12"
                        height="12"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g className="arrow-flip-path-1">
                          <path
                            d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                            fill="currentColor"
                          ></path>
                        </g>
                        <g className="arrow-flip-path-2">
                          <path
                            d="m56 6h-48c-1.104 0-2 .896-2 2s.896 2 2 2h43.171l-44.585 44.586c-.781.781-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.024-.195 1.414-.586l44.586-44.586v43.172c0 1.104.896 2 2 2s2-.896 2-2v-48c0-1.104-.896-2-2-2z"
                            fill="currentColor"
                          ></path>
                        </g>
                      </svg>
                    )}
                  </button>
                </div>
                {/* /.col-lg-12 */}
              </div>
              {/* /.row */}
            </form>
            {/* /.contact-panel-form */}
          </div>
          {/* /.contact-panel */}
        </div>
        {/* /.row */}
      </div>
      {/* /.container */}
    </section>
  );
};

export default ContactForm;
